import { alignSelfVariants } from 'client/constants/alignSelfOptions'
import { CarouselSlideUi } from 'common/components/entities/Carousel'
import { AlignSelfType } from 'common/types/styleTypes'
import React, { useEffect, useRef } from 'react'

type CarouselSlideProps = {
  children: React.ReactElement
  activeSlideIndex: number
  slideIndex: number
  alignSelf?: AlignSelfType
  mobileAlignSelf?: AlignSelfType
}

const CarouselSlide = ({
  children,
  activeSlideIndex,
  slideIndex,
  alignSelf = alignSelfVariants.center,
  mobileAlignSelf,
}: CarouselSlideProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const active = slideIndex === activeSlideIndex

  useEffect(() => {
    if (ref.current && active) {
      ref.current.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      })
    }
  }, [active])

  return (
    <CarouselSlideUi
      ref={ref}
      active={active}
      alignSelf={alignSelf}
      mobileAlignSelf={mobileAlignSelf}
    >
      {children}
    </CarouselSlideUi>
  )
}

export default React.memo(CarouselSlide)
